import { SubTypeOption } from '../../../../../../api/gms/group-category/group-category-api-state';
import { UniformCoverageTypes } from '../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.state';
import { RowData } from '../../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.state';
import { InputByLevelRanking } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.state';

interface Props {
    isBySalaryRank: boolean;
    selectedCoverageTypeState: SubTypeOption | null
    selectedAmountOfLoansCheckBox: SubTypeOption | null
    inputsByUniformCoverage: UniformCoverageTypes | null
    inputsBySalaryRank: RowData[];
    inputsByLevelRanking: InputByLevelRanking[]
    isProductGCLI: boolean;
}

export default function AttachableRiderHeaderTable({ isBySalaryRank, selectedCoverageTypeState, inputsByLevelRanking, inputsBySalaryRank, inputsByUniformCoverage, isProductGCLI, selectedAmountOfLoansCheckBox }: Props) {
    
    
    const isAmountOfLoan = isProductGCLI
    const headerClassName = "min-w-[140px] border-b border-l border-gray-200 bg-gray-100 px-3 py-3 text-center text-[11px] font-semibold tracking-wide text-gray-600";

    return (
        <thead>
            <tr>
                {/* <th className="sticky left-0 z-30 min-w-[220px] border-b border-gray-200 bg-gray-100 px-4 py-3 text-left text-[11px] font-semibold tracking-wide text-gray-700 shadow-[4px_0_10px_rgba(0,0,0,0.04)]"> */}
                <th className="sticky left-0 z-30 min-w-[160px] w-[160px] border-b border-gray-200 bg-gray-100 px-4 py-3 text-left text-[11px] font-semibold tracking-wide text-gray-700 shadow-[4px_0_10px_rgba(0,0,0,0.04)]">
                    Selected Rider
                </th>
                {isAmountOfLoan ? (
                    <th className={headerClassName}>
                        {selectedAmountOfLoansCheckBox?.name}
                    </th>
                ) : selectedCoverageTypeState?.name === "Uniform Coverage" ? (
                    <th className={headerClassName}>
                        {inputsByUniformCoverage?.label}
                    </th>
                ) : isBySalaryRank ? (
                    inputsBySalaryRank.map((row, i) => (
                        <th key={i} className={headerClassName}>
                            {row.designation}
                        </th>
                    ))
                ) : (
                    inputsByLevelRanking.map((col, i) => (
                        <th key={i} className={headerClassName}>
                            {col.label}
                        </th>
                    ))
                )}
            </tr>
        </thead>
    )
}
